/**
 * El corte de comisiones: el plan cierra periodo a FIN DE MES ("YYYY-MM"
 * es el `periodId` de cada comisión). El próximo corte es el último
 * instante del mes en curso, y la barra enseña qué tanto del mes ya
 * corrió. Pura, para probarla con fechas fijas.
 */
export function nextCommissionCutoff(now: Date): { cutoff: Date; periodStart: Date; progress: number } {
  const periodStart = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0, 0);
  // Día 0 del mes siguiente = último día de este; 23:59:59.999.
  const cutoff = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999);
  const total = cutoff.getTime() - periodStart.getTime();
  const elapsed = now.getTime() - periodStart.getTime();
  const progress = total > 0 ? Math.min(1, Math.max(0, elapsed / total)) : 0;
  return { cutoff, periodStart, progress };
}
